
<div class="container-scroller bg-bluebarsignup">
  <div class="center-div2">

    <div *ngIf="UserAccountRequestStep === 0">
      <div class="row">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="card card-width-wide box-shadow3">
            <div class="card-header background-white padding-bottom">

              <!--<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">

    <span aria-hidden="true">&times;</span>
  </button>-->
              <div class="row">
                <div class="col-md-3">
                  <a class="user-image-circle-65px">
                    <img src="../../../../../../wwwroot/healins-assets/images/RNCloud_logo.png"
                         height="30px" class="margin-left-13px signup-image-width">
                  </a>
                </div>
                <div class="col-md-8 text-align-right padding-right-0px">
                  <i class="fas fa-user-circle font-size-singoutn margin-right-18px"></i>
                  <div>
                    <label class="margin-bottom-0px">
                     Registry
                    </label>
                  </div>

                </div>

              </div>
              <h4 class="title font-size-16px margin-top-27" id="myModalLabel">Sign Up</h4>



            </div>



            <div class="card-body background-white">

              <div class="col-md-12 col-xs-12 login_control">
                <div class="row">
                  <!--<div class="col-md-6 col-xs-12 login_control">-->
                  <div class="control col-md-3 col-xs-12 padding-right-0px margin-left-auto margin-top-auto">
                    <div class="label font-size-11px label-style2">Your Name<span>*</span></div>
                  </div>

                  <label class="col-md-5 padding-left-0px margin-right-auto">
                    <!--<i class="input-icon fas fa-user"></i>-->
                    <input type="text" class="form-control border-bottom-tbl"
                           name="CurrentUserAccountRequest.ActorName"
                           id="CurrentUserAccountRequest.ActorName"
                           placeholder="Name" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           [(ngModel)]="CurrentUserAccountRequest.ActorName" required #ActorName="ngModel" maxlength="20" minlength="1">
                    <small class="form-text text-danger"
                           *ngIf="(!ActorName.valid && (ActorName.dirty || ActorName.touched) && ActorName.errors.required)">(Name cannot be  blank)</small>
                    <small class="form-text text-danger"
                           *ngIf="(!ActorName.valid && ActorName.errors.pattern)">(special characters are not allowed)</small>

                  </label>


                </div>

                <!--<div class="control col-md-6 col-xs-12 " hidden>
                  <div class="label font-size-11px">Time Zone<span>*</span></div>
                  <label class="col-12">
                    <select class="form-control " id="CurrentUserAccountRequest.TimeZoneCode"
                            style="height:28px;"
                            name="CurrentUserAccountRequest.TimeZoneCode" [(ngModel)]="CurrentUserAccountRequest.TimeZoneCode"
                            (change)="onChangeTimeZone($event.target.value)" #TimeZoneCode="ngModel"
                            required>

                      <option selected="" value="0"></option>
                      <option *ngFor="let R of CurrentTimeZoneMasterController" [value]="R.TimeZoneCode">

                        {{R.DisplayName}}
                      </option>


                    </select>
                    <small class="form-text text-danger"
                           *ngIf="(!TimeZoneCode.valid && (TimeZoneCode.dirty || TimeZoneCode.touched))">(Required)</small>


                  </label>
                </div>-->

                <div class="row">
                  <div class="control col-md-3 col-xs-12 padding-right-0px margin-left-auto margin-top-auto">
                    <div class="label font-size-11px text-align-center label-style2">Mobile Number<span>*</span></div>
                  </div>
                  <label class="col-md-5 padding-left-0px margin-right-auto">
                    <!--<i class="input-icon fas fa-mobile-alt"></i>-->
                    <input type="text" class="form-control  border-bottom-tbl"
                           name="CurrentUserAccountRequest.MobileNo"
                           id="CurrentUserAccountRequest.MobileNo"
                           placeholder="Mobile Number"
                             mask="(000) 000-0000"
                           [(ngModel)]="CurrentUserAccountRequest.MobileNo" required
                           maxlength="10" pattern="[0-9]{10}" #MobileNo="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!MobileNo.valid && (MobileNo.dirty || MobileNo.touched))">(Provide Valid Mobile Number )</small>

                  </label>

                </div>

                <div class="row">
                  <div class="control col-md-5 col-xs-12 padding-right-0px margin-top-9px ">
                    <div class="label font-size-11px text-align-center label-style2">Email ID (User Name)<span>*</span></div>
                  </div>
                  <label class="col-md-5 padding-left-0px margin-right-auto">
                    <input type="email" class="form-control  border-bottom-tbl"
                           name="CurrentUserAccountRequest.UserName"
                           id="CurrentUserAccountRequest.UserName"
                           placeholder="Email ID (User Name)"
                           [(ngModel)]="CurrentUserAccountRequest.UserName" required pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                           #Email="ngModel" maxlength="30" minlength="4">
                    <small class="form-text text-danger"
                           *ngIf="(!Email.valid && (Email.dirty || Email.touched))">(Provide Valid Email)</small>
                  </label>

                </div>

                <div class="row">
                  <div class="control col-md-3 col-xs-12 padding-right-0px margin-left-auto margin-top-auto">
                    <div class="label font-size-11px text-align-center label-style2">Set Your Password<span>*</span></div>
                  </div>
                  <label class="col-md-5 padding-left-0px margin-right-auto">
                    <!--<i class="input-icon fas fa-key"></i>-->
                    <input type="password" class="form-control  border-bottom-tbl"
                           name="CurrentUserAccountRequest.Password"
                           id="CurrentUserAccountRequest.Password" pattern="^[\sa-zA-Z0-9,._\-?,$@!%*?&]*$"
                           placeholder="Password" [(ngModel)]="CurrentUserAccountRequest.Password" required #Password="ngModel" minlength="8" maxlength="15">

                    <small class="form-text text-danger"
                           *ngIf="(!Password.valid && (Password.dirty || Password.touched)  && Password.errors.minlength && !isRequesting)">(Mininum 8 Chars)</small>
                    <!--<small class="form-text text-danger"
                           *ngIf="(!Password.valid && Password.errors.pattern && !Password.errors.minlength && !isRequesting) ">(special characters are not allowed)</small>-->

                  </label>



                </div>


               





              </div>
            </div>

            <div class="card-footer">
              <div class="control float-left">
                <label class="checklabel col-12 font-size-11px display-flex">
                  <input type="checkbox" class="margin-right-3px margin-tb-auto"
                         name="CurrentUserAccountRequest.IsAcceptTerms"
                         id="CurrentUserAccountRequest.IsAcceptTerms" [(ngModel)]="CurrentUserAccountRequest.IsAcceptTerms" required
                         checked #IsAcceptTerms="ngModel">
                  <small class="form-text text-danger "
                         *ngIf="(!IsAcceptTerms.valid && (IsAcceptTerms.dirty || IsAcceptTerms.touched))">(Required)</small>
                  I agree to the    <a href="" class="margin-lr-3px">  Terms and Conditions </a>  of RNCLOUD services.
                </label>
              </div>
              <!--<a (click)="onForgotPassword()" class="float-left nav-link-hand margin-left-17px">Forgot Password</a>-->
              <button type="submit" [disabled]="!f.valid" class="btn btn-primary nav-link-hand float-right font-size-14px margin-right-31" *ngIf='!isRequesting'>Register</button>
            </div>



          </div>
        </form>
      </div>
    </div>
    <div *ngIf="UserAccountRequestStep === 1">
      <div class="row">
        <form class="form" novalidate="" (ngSubmit)="onOTPSubmit()" #of="ngForm">
          <div class="card card-width">
            <div class="card-header background-white padding-bottom">
              <div class="row">
                <a class="user-image-circle-65px">
                  <img src="../../../../../../wwwroot/healins-assets/images/RNCloud_logo.png"
                       height="30px" class="margin-left-13px">
                </a>
              </div>
              <h4 class="title font-size-16px margin-top-27" id="myModalLabel">Account Activation</h4>
            </div>
            <div class="card-body background-white">

              <div class="col-md-12 col-xs-12 login_control">

                <div class="control">
                  <div class="label font-size-11px">Enter Activation Code (OTP)<span>*</span></div>
                  <label class="col-12">
                   
                    <input type="text" class="form-control border-bottom-tbl"
                            name="jonny"
                           acceptname="CurrentOTPToActivateAccount.ActivationCode"
                           id="CurrentOTPToActivateAccount.ActivationCode" placeholder="OTP"
                           [(ngModel)]="ACTCODE" minlength="6" maxlength="6" pattern="[0-9]{6}" required #ActivationCode_="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!ActivationCode_.valid && (ActivationCode_.dirty || ActivationCode_.touched))">(Provide Valid OTP)</small>

                  </label>

                </div>
              </div>
            </div>
            <div class="card-footer">
              <!--<a (click)="onForgotPassword()" class="float-left nav-link-hand margin-left-17px">Forgot Password</a>-->
              <!--<button type="button" class="float-left btn btn-secondary nav-link-hand font-size-14px margin-right-31" (click)="onResendOTP()" *ngIf='!isRequesting'>Resend OTP</button>-->
              <button type="button" (click)="onResendOTP()"
                      class="btn .actions-btn-prime2 nav-link-hand float-left font-size-14px "
                      *ngIf='!isRequesting'>
                Resend
              </button>
              <!--<button type="submit" [disabled]="!of.valid" class="btn btn-primary nav-link-hand float-right font-size-14px margin-right-31" *ngIf='!isRequesting'></button>-->
              <button type="submit" [disabled]="!of.valid" class="btn btn-primary nav-link-hand float-right font-size-14px margin-right-31" *ngIf='!isRequesting'>Confirm</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
